import React from 'react';
import send from '../../../../assets/send.svg';
import sendYellow from '../../../../assets/sendYellow.svg';
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";

interface SendProps {
    onClick: (event: React.MouseEvent) => void;
}

export const Send: React.FC<SendProps> = ({ onClick }) => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { hasAttachment, hasText, isCurrentPromptImportant, isInitializing, mediaItemsInProgress } = dynamicStateObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    const handleClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        onClick(event);
    };

    const getButtonDimensions = () => {
        if (environment === "vscode") return "h-7 w-7";
        else return "h-8 w-8";
    }
    const buttonDimensions = getButtonDimensions();

    // If the loading state isn't initializing and there is something to submit
    const isSubmittable = !isInitializing && (hasAttachment || hasText) && mediaItemsInProgress.length === 0;
    return (
        <button className={`${buttonDimensions} ${isCurrentPromptImportant ? "" : "invert-0 dark:invert"} transition-opacity duration-200 ${!isSubmittable ? `${theme === "dark" ? "opacity-30" : "opacity-60"} cursor-default` : ""}`} onClick={handleClick}>
            <img src={isCurrentPromptImportant ? sendYellow : send} alt="Send"/>
        </button>
    );
};
